"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SnetFooterCopyrightModule = _interopRequireDefault(require("./SnetFooterCopyright.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetFooterCopyright = () => {
  const year = new Date().getFullYear();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
    className: _SnetFooterCopyrightModule.default.footerDivider
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: _SnetFooterCopyrightModule.default.copyrightText
  }, "Copyright \xA9 ", year, " SingularityNET All rights reserved."));
};
var _default = exports.default = SnetFooterCopyright;